export const PROCESS_TYPE_SELECTED = 'orderItemForm/PROCESS_TYPE_SELECTED';
export const ON_CHANGE_CHECK_VALUES = 'orderItemForm/ON_CHANGE_CHECK_VALUES';
